import { ErrorMessage } from '@hookform/error-message';
import { DatePicker, IDatePickerProps } from 'app/components/Common/DatePicker';
import { TextField, Typography } from '@mui/material';
import React from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { theme } from 'styles/global-styles';

export interface IFormInputDatePickerV2 extends Omit<IDatePickerProps, 'onChange' | 'value' | 'renderInput'> {
  name: string;
  required: boolean;
  isDisabled?: boolean;
  handleChange?: any;
}

export const FormInputDatePickerV2 = (props: IFormInputDatePickerV2) => {
  const { control, formState: { errors } } = useFormContext();

  return (
    <Controller
      control={control}
      rules={{ required: props.required }}
      name={props.name}
      render={({ field }) => (
        <>
          <DatePicker
            renderInput={params => <TextField {...params} variant="filled" />}
            label={props.label}
            disabled={props.isDisabled}
            {...field}
            onChange={e => {
              if (props.handleChange) props.handleChange(e);
              field.onChange(e);
            }}
          />
          <ErrorMessage
            errors={errors}
            name={props.name}
            render={({ message }) => (
              <Typography style={{ color: theme.palette.framework.system.coralRed, fontSize: '0.75rem' }}>
                {errors[props.name].type === 'required' ? 'Required' : message}
              </Typography>
            )}
          />
        </>
      )}
    />
  );
};
